import { BREAKPOINTS } from '@presentation/styles';
import type { FC } from 'react';
import { useState } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import Slider from 'react-slick';
import { CardItemWrapper } from '..';
import * as Styled from './styled';
import type { CardItemSliderProps } from './types';

export * from './types';

const DEFAULT_SETTINGS = {
  dots: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  arrows: false,
  responsive: [
    {
      breakpoint: BREAKPOINTS.desktop,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
      },
    },
    {
      breakpoint: BREAKPOINTS.tablet,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        dots: true,
      },
    },
    {
      breakpoint: BREAKPOINTS.small,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
};

export const CardItemSlider: FC<CardItemSliderProps> = (props) => {
  const { items = [], overrideSettings = {}, whiteArrows = false } = props;
  const [slider, setSlider] = useState<Slider | null>(null);

  const settings = {
    ...DEFAULT_SETTINGS,
    infinite: items?.length > 4,
    ...overrideSettings,
  };

  return (
    <Styled.SliderWrapper>
      <Slider ref={(obj) => setSlider(obj)} {...settings}>
        {items.map((item, index) => (
          <CardItemWrapper key={index}>{item}</CardItemWrapper>
        ))}
      </Slider>

      {settings.infinite && (
        <>
          <Styled.ButtonWrapper onClick={slider?.slickPrev} whiteArrows={whiteArrows}>
            <FaAngleLeft />
          </Styled.ButtonWrapper>
          <Styled.ButtonWrapper isRight onClick={slider?.slickNext} whiteArrows={whiteArrows}>
            <FaAngleRight />
          </Styled.ButtonWrapper>
        </>
      )}
    </Styled.SliderWrapper>
  );
};
